import { render } from "./DashboardRegistrations.vue?vue&type=template&id=5f5e937d&scoped=true&ts=true"
import script from "./DashboardRegistrations.vue?vue&type=script&lang=ts"
export * from "./DashboardRegistrations.vue?vue&type=script&lang=ts"

import "./DashboardRegistrations.vue?vue&type=style&index=0&id=5f5e937d&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5e937d"]])

export default __exports__